import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';
import { Wrapper } from './Category.styles';
import { CategoryType } from '../../../../../api/useWorkflowQuery';
import { COLORS } from '../../../../../PulseCheck.meta';

export interface Props {
  number?: number;
  isDragging?: boolean;
  category: CategoryType;
}

export const Category = ({ category, number, isDragging }: Props) => {
  return (
    <Wrapper isDragging={isDragging}>
      <Box
        display="grid"
        width={40}
        css="place-content: center"
        borderRight="1px solid"
        borderColor="neutral.200"
      >
        <AnimatePresence>
          {number && (
            <motion.span
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              style={{ lineHeight: 0 }}
            >
              <Text fontSize="h5" fontWeight={600}>
                {number}
              </Text>
            </motion.span>
          )}
        </AnimatePresence>
      </Box>

      <Box display="flex" flex={1} alignItems="center" px="8" py="16" css="gap: 8px">
        <Box width={24} height={24} style={{ color: COLORS.primary }}>
          <category.icon />
        </Box>

        <Box display="flex" flexDirection="column" flex={1}>
          <Text fontSize="h6" fontWeight={600}>
            {category.name}
          </Text>
          <Text color="neutral.500">{category.description}</Text>
        </Box>
      </Box>

      <Icon
        className="fas fa-grip-vertical"
        color="neutral.500"
        css="align-self: center"
        aria-label="drag handle"
        mr="12"
      />
    </Wrapper>
  );
};
